export const VIEW_TYPE_THUMBNAIL = 'THUMBNAIL';
export const VIEW_TYPE_LIST = 'LIST';

export const CATEGORIES = {
	ALL_REPORTS: 'All Reports',
	DEFAULT: 'Default Reports',
	CUSTOM: 'Custom Reports',
};

export const REPORT_TYPE = {
	DEFAULT: 'DEFAULT',
	CUSTOM: 'CUSTOM',
};
